import { Dayjs } from "dayjs"
import {
  IWarrantsJob,
  WarrantsJobStatus,
} from "@/models/admin/warrantsJob/warrantsJob.types"
import { sentenceCase } from "@/helpers/stringHelpers"

export class WarrantsJob implements IWarrantsJob {
  constructor(
    public id: number,
    public status: WarrantsJobStatus,
    public message: string | null,
    public startedAt: Dayjs,
    public endedAt: Dayjs | null,
    public createdAt: Dayjs,
    public updatedAt: Dayjs,
    public deletedAt: Dayjs | null,
  ) {}

  get isDeleted(): boolean {
    return this.deletedAt !== null
  }

  get statusDisplay(): string {
    return sentenceCase(this.status)
  }
}
